import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateReaderForm } from "../../forms"

export const CreateReader: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreateReaderForm />
		</VStack>
	)
}
